module.exports = __webpack_public_path__ + "img/s1-2-ja.ebcefab1.jpg";